<template>
  <TopGradientBlockLayout class="text-center font-bold">
    <div class="text-sm text-text-secondary mt-0-5 mb-7">{{ $t('value') }}</div>
    <div class="text-text text-xl mb-4 whitespace-no-wrap">
      {{ displayCurrencyValue(value, portfolioCurrency, true, displayValueAsInt) }}
    </div>
    <div class="text-md text-text-ternary">
      {{ displayCurrencyValue(sum_usd, {}, false, displaySumAsInt) }} $
    </div>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import {mapGetters, mapState} from "vuex";

export default {
  name: "Value",
  components: {TopGradientBlockLayout},
  props: ['value', 'sum_usd'],
  computed: {
    ...mapGetters('investments/portfolios', ['portfolioCurrency']),
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    displayValueAsInt() {
      return this.value >= 1000000
    },
    displaySumAsInt() {
      return this.sum_usd >= 1000000
    }
  },
  i18n: {
    messages: {
      en: {
        value: 'Value'
      },
      ru: {
        value: 'Стоимость'
      }
    }
  }
}
</script>